import React from "react";
import AdminHeader from "./AdminHeader";
import { observer } from "mobx-react-lite"
import MainFooter from "./AdminFooter";

type DefaultLayoutProps = {
	children: React.ReactNode;
};
const DefaultLayout = observer(({children}: DefaultLayoutProps) => {
	return (
		<div className="fww-root">
			<AdminHeader />
			<div className="fww-container">
				{children}
				<MainFooter />
			</div>
		</div>
	);
});
export default DefaultLayout;